import { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2, FileSpreadsheet } from "lucide-react";
import api from "@/lib/api";
import { tBtnGhost, CsvImportButton } from "./trackUi";

export default function TrackReports({ orgId, canWrite, onImported }) {
  const [busy, setBusy] = useState("");
  const dl = async (kind, filename) => {
    setBusy(kind);
    try {
      const res = await api.get(`/track/reports/${kind}.csv?organization_id=${orgId}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = filename; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Export failed."); } finally { setBusy(""); }
  };
  const Card = ({ title, desc, children }) => (
    <div className="border border-white/10 bg-[#121212] p-5"><div className="flex items-center gap-2 mb-1"><FileSpreadsheet size={16} className="text-white/50" /><p className="font-bold">{title}</p></div><p className="text-white/40 text-xs mb-4">{desc}</p>{children}</div>
  );
  return (
    <div data-testid="track-reports">
      <h1 className="font-display font-black uppercase tracking-tighter text-4xl mb-6">Reports</h1>
      <div className="grid sm:grid-cols-2 gap-4">
        <Card title="Roster Export" desc="Download the full athlete roster as a CSV file.">
          <button data-testid="export-roster" onClick={() => dl("roster", "roster.csv")} className={tBtnGhost}>{busy === "roster" ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />} Download roster.csv</button>
        </Card>
        <Card title="Results Export" desc="Download all recorded meet results as a CSV file.">
          <button data-testid="export-results" onClick={() => dl("results", "results.csv")} className={tBtnGhost}>{busy === "results" ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />} Download results.csv</button>
        </Card>
        {canWrite && (
          <Card title="Import Results" desc="Columns: Athlete, Event, Mark, Meet, Date, Season. Athletes are matched by name.">
            <CsvImportButton testid="import-results" endpoint="/track/import/results" orgId={orgId} label="Import results CSV" onDone={onImported} />
          </Card>
        )}
        {canWrite && (
          <Card title="Import Roster" desc="Columns: First Name, Last Name, Gender, Grad Year, Events.">
            <CsvImportButton testid="import-roster" endpoint="/track/import/athletes" orgId={orgId} label="Import roster CSV" onDone={onImported} />
          </Card>
        )}
      </div>
    </div>
  );
}
